<script setup>
import { Head } from '@inertiajs/vue3';
</script>

<script>
export default {
    props: {
        status: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            title: {
                403: '403: Hozzáférés megtagadva!',
                404: '404: Az oldal nem található!',
                500: '500: Belső szerverhiba történt!',
                503: '503: Szolgáltatás nem elérhető!',
            }[this.status],
            description: {
                403: 'Sajnáljuk, Önnek nincs jogosultsága a hozzáféréshez.',
                404: 'Előfordulhat, hogy elírtad a webcímet, az oldal sohasem létezett, vagy időközben máshová költözött.',
                500: 'Sajnáljuk, valami hiba történt a szervereinken.',
                503: 'Oldalunkon tervezett karbantartást végzünk. Kérjük, nézz vissza később.',
            }[this.status]
        }
    },
}
</script>

<template>

    <Head :title="$t(title)" />

    <header class="header">
        <div class="header-body header-body-subpage">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-auto col-lg text-center text-sm-right text-lg-left">
                        <h1 class="header-h1">{{ $t('Hiba!') }}</h1>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <div class="header-placeholder"></div>

    <div class="subpage-content">
        <div class="container subpage-container">
            <div class="row">
                <main class="main col-12">
                    <section>
                        <div class="row section-title d-none">
                            <div class="col-12">
                                <h2>{{ $t(title) }}</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <p class="h3 my-4">{{ $t(title) }}</p>
                                <p class="h3 my-4">{{ $t(description) }}</p>
                                <a v-if="status != 503" :href="route('home', { 'locale': $page.props.locale })" class="btn btn-primary">{{ $t('Vissza a főoldalra') }}</a>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    </div>

</template>
